import React, { useEffect, useRef, useState } from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, message } from 'antd';
import { CloudSyncOutlined, FileAddOutlined, ArrowLeftOutlined, ImportOutlined,
  FileZipOutlined } from '@ant-design/icons'
import IndividualsRepository from '../../components/vocabs/IndividualsRepository'
import NewElement from '../../components/editor/NewElement';
import VocabsFilter from '../../components/vocabs/VocabsFilter';
import Tags from '../../components/tags/Tags';
import Langs from '../../components/langs/Langs';
import Alphabet from '../../components/alphabet/Alphabet';
import Search from '../../components/search/Search';
import FilterData from '../../components/filter/FilterData';
import { RdfTriplet, VocabsRepository, VocabsIndividual} from '../../redux';
import { subsetByLangOrEmpty, getCountValue } from '../../virtuoso/helper';
import { DetailLinkCard } from '../../components/adms/DetailLinkCard';
import { makePrefixIRIByType } from '../../utils/uriUtil';
import ImportIndividual from '../../components/import/ImportIndividual';
import ExportIndividual from '../../components/export/ExportIndividual';

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("AssetList.js showViewDetail", selected);
	return <Modal style={{minWidth: "80%"}} open={true} 
    title="Детальная информация" 
    cancelText="Отмена" onCancel={onCancelOperation} 
    cancelButtonProps={{ disabled: true, dispaly: "none" }}
    okText="Ок" onOk={onFinishOperation}>
        <DetailLinkCard triplet={selected} factory={factory}/>
	  </Modal>
}

/**
 *  Отображение формы добавление нового элемента в каталоге
 * 
 *  Модальная форма на основе примера см. https://stackblitz.com/edit/ant-modal-form?file=index.js
 */
const showAdd = (formRef=f=>f, factory, rdfTypes, onFinishOperation=f=>f, onCancelOperation=f=>f, sksaNamespace) => {  
  return <Modal 
      style={{minWidth: 700}} 
      open={true}  
      title="Добавление нового элемента" 
      cancelText="Отменить" onCancel={onCancelOperation}
      okText="Добавить" onOk={onFinishOperation}
      destroyOnHidden>	
        <NewElement 
          formRef={formRef} 
          factory={factory} 
          rdfTypes={rdfTypes} 
          prefixURI={sksaNamespace}
          onMakePrefixURI={selectedType => {
            return makePrefixIRIByType(sksaNamespace, selectedType);
          }}
        />
	  </Modal>
};

/** Добавить условие в список. Для словий с одной схемой формируется массив значений */
const includedConditions = (conditions, condition) => {
  //Проверим, что такая схема есть и тогда сделаем массив значений
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (!Array.isArray(scheme[0].value))
      scheme[0].value = [scheme[0].value];
    scheme[0].value.push(condition.value);
    return conditions;
  }
  return conditions.concat([condition])
}
/** Исключить условие из поиска */
const excludedConditions = (conditions, condition, taxonomy, lang) => {
  //console.log("AssetList.js excludedConditions", conditions, condition, taxonomy, lang);
  //Проверим, что такая схема есть и тогда исключим из массива значений значение condition
  const scheme = conditions.filter(item => item.scheme == condition.scheme);
  if (scheme.length>0){
    if (Array.isArray(scheme[0].value)){
        scheme[0].value = scheme[0].value.filter(item => item != condition.value)
        if (scheme[0].value.length == 1){
            scheme[0].value = scheme[0].value[0]
            //Надо обновить label, т.к. может он может не совпадать
            //label задаётся при добавлении условия, для массива label - первый заданный condition
            //см. отображение условий в FilterData.js
            //const schemes = taxonomy.filter(item => item.IRI && item.IRI.value && (item.IRI.value == condition.scheme));
            //const concepts = (schemes.length>0)?subsetByLangOrEmpty(schemes[0].concepts, lang, "IRI", "Label"):[];
            //const labels = concepts.filter(concept => concept.IRI.value == scheme[0].value);
            //scheme[0].label = (labels.length>0)?labels[0].Label.value:scheme[0].value;
        }
        return conditions;
    }
  }
  return conditions.filter(item => !((item.predicate==condition.predicate)&&(item.operator==condition.operator)&&(item.value==condition.value)));
}
/** Компонента для получения и отображения списка активов. 
 *  Доступные активы фиксируются в vadms.
 * Линковка props и vadms происходит в containers.js
 */
class ValuesVocabsList extends React.Component {

    state = {
      modal: "none",		//Состояние модельного окна. none - не показывается, add - отобразить диалог добавление нового элемениа
    };

    formRef = React.createRef();
  
  //Событие об изменение состава условий отбора
  // include - true - добавить условие, false - удалить условие.
  // condition - само условие. 
  // Если условия из одной схемы, то создать массив, который будет объединятся по ИЛИ
  onChangeListConditions (include, condition) {
    const {conditions, actions, taxonomy, lang, onChangeConditions} = this.props;
    console.log("ValuesVocabsList.js",this, include, condition);
    let filter = conditions;
    if (Array.isArray(condition)){
      condition.forEach(item => 
        filter = (include)
          ? includedConditions(filter, item) 
          : excludedConditions(filter, item, taxonomy, lang)
      );
    } else {
      filter = (include)
        ? includedConditions(conditions, condition) 
        : excludedConditions(conditions, condition, taxonomy, lang);
    };
    console.log("ValuesVocabsList.js",this, include, condition);
    if (onChangeConditions) 
      onChangeConditions(VocabsRepository, filter);
  };

    onSearchByAlphabet(include, char){
      const {onAlphabetSearch, conditions} = this.props;
      if (onAlphabetSearch) 
        onAlphabetSearch(VocabsRepository, (include)?char:"", conditions);      
    }

    onSearchByName (pattern) {
      //console.log("onSearchByName (pattern)", pattern, this);
      const {onNameSearch, conditions} = this.props;
      if (onNameSearch) 
        onNameSearch(VocabsRepository, pattern, conditions);
    }

    onRefresh (e) {
      e.preventDefault();
      const {conditions, rdfTypes, lang} = this.props;
      this.props.onRefreshList(VocabsRepository, conditions, rdfTypes, lang);
    };
    onNewVocab(e){
      e.preventDefault();
      this.setState({modal:"add"});
    };

  onImportDialog(e){
    e.preventDefault();
    this.setState({modal:"import"});
  }

  onExportDialog(e){
    e.preventDefault();
    this.setState({modal:"export"});
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    //console.log("AssetList.js handlers", triplet, operation, this);
    const {catalog} = this.props;
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement) 
      this.props.onDetailElement(VocabsIndividual, catalog.iri, triplet)
      .then (result =>{
        //console.log("AssetList.js handlers 2", result);
        this.setState({detail: triplet});
    });
  };

  cancelOperation(){
    this.setState({modal:"none", detail: undefined});
  };

  /** Закрыть детальную информацию (возможно из карточки каталога) */
  cancelDetail(){
    this.setState({detail: undefined});
  };

  /** Вызывается при добавлении новой карточки. Данные см. NewElement.js */
  submitOperation() {
      const { sksaNamespace, router, onSelected } = this.props;
      const form  = this.formRef.current;
      form.validateFields()
        .then(values => {
          const IRI = (values.IRI.startsWith("http://") || values.IRI.startsWith("https://")) 
            ? values.IRI 
            : sksaNamespace + values.IRI;
          //Проверим, что IRI отсутствует
          RdfTriplet.countSubject(IRI)
            .then ( response =>{
              const count = getCountValue(response.bindings);
              if (count>0){
                message.error(`IRI ${IRI} уже существует. Задайте другой идентификатор.`);
                return;
              }
              const label = values["http://www.w3.org/2000/01/rdf-schema#label"];
              const rdfType = values["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"];
              this.props.onAddElement(VocabsRepository, IRI, rdfType, label.text, label.lang)
                .then (response =>{ 
                  message.success("Добавление записи завершено успешно.");
                  this.setState({modal:"none"}); 
                  if (router && onSelected)
                    onSelected(IRI, VocabsIndividual, router.navigate)                    

                })
                .catch(e => {  message.error(`Ошибка при добавлении элемента в каталог. ${e}`); });                  
            })
            .catch(e => {  
              message.error(`Не удалось определить уникальность IRI. ${e}`); 
            });
        })
        .catch(info => {
          message.error(i18n.t('skos.scheme.message.e_new', {detail: info}));
        });
    };
    
  check(){

  };
  
  render() {
        //console.log(this);
        const { modal, detail } = this.state;
        const {rdfTypes, conditions, isSignedIn, inGroup, factory, lang, sksaNamespace, highlight} = this.props;
        //Условия отбора задаются в vadms см. AdmsActions с использованием действий добавления/удаления условия 
        const isCondition = (conditions && Array.isArray(conditions))?conditions.length>0: false;
        return (
            <div>
                <Row><h1>{i18n.t('views.admin.landing.vocabs')}</h1></Row>
                <Row>
                    <Col className="csi_search_bar_title" span={6} style={{}}></Col>
                    <Col className="csi_search_form_div" span={18} style={{}}><Search onSearch={(value) => this.onSearchByName(value)} /></Col>
                </Row>
                <Row>
                    <Col className="csi_filters" span={6} style={{}}>
                        {isCondition && (
                          <Row style={{}} className="filterBrowserDiv"> <FilterData actions={VocabsRepository} onChange={(i,c)=> this.onChangeListConditions(i,c)}/></Row>
                          )}
                        <Row style={{}}> 
                          <VocabsFilter 
                            rdfTypes={rdfTypes} selected={conditions} 
                            onChange={(i,c)=> this.onChangeListConditions(i,c)} 
                            highlight={highlight}
                          />
                        </Row>
                        <Row style={{display: "none"}}> <Tags/></Row>
                    </Col>
                    <Col className="csi_asset_list" span={18} style={{}}>
                        <Row style={{display: "none"}}><Alphabet selected={conditions} onChange={(i,c)=> this.onSearchByAlphabet(i,c)} /></Row>                            
                        <Row style={{display: "none"}}>
                          <Col style={{display: "none"}} span={24}>Язык каталога моделей  <Langs /></Col>
                        </Row>
                        <Row>
                          <Col span={22}>
                              <Tooltip placement="top" title={i18n.t('views.admin.return_admin_panel')}>
                                <Button icon={<ArrowLeftOutlined />} onClick={(e)=> this.props.router.navigate("/")}></Button>
                              </Tooltip>
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.adms.list_reload_title')}>
                                  <Button icon={<CloudSyncOutlined />} onClick={(e)=> this.onRefresh(e)}></Button>
                                </Tooltip>
                            </Col>
                            <Col span={2} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                              {isSignedIn && inGroup.Operator && (
                                <>
                                  <Tooltip placement="top" title={i18n.t('views.admin.add_vocabs_individual')}>
                                    <Button icon={<FileAddOutlined />} onClick={(e)=> this.onNewVocab(e)}></Button>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.admin.import_vocabs_individual')}>
                                    <Button icon={<ImportOutlined />} onClick={(e)=> {(this.onImportDialog(e))}} ></Button> 
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.adms.export_card')}>
                                    <Button icon={<FileZipOutlined />} onClick={(e)=> this.onExportDialog(e)}/>
                                  </Tooltip>                              
                                </>
                              )}
                            </Col>
                        </Row>
                        <Row id="IndividualsRepository" >
                          <Col span={24}><IndividualsRepository {...this.props} /></Col>
                        </Row>
                    </Col>
                </Row>
                { (modal=="add") && showAdd(this.formRef, factory, rdfTypes, ()=>this.submitOperation(), ()=>this.cancelOperation(), sksaNamespace)}
                {detail && showViewDetail(this.modalFormRef, detail, factory, ()=>this.cancelDetail(), ()=>this.cancelDetail())}
                { modal=="import" && <ImportIndividual open={true} onClose={()=> this.cancelOperation()} />}
                { modal=="export" && <ExportIndividual open={true} onClose={()=> this.cancelOperation()} conditions={conditions} rdfTypes={rdfTypes}/>}
            </div>            
        )
    }
}

export default ValuesVocabsList;